const ERROR_BLOCK_DEFAULT_PROPS = {
  title: 'Validation failed',
  buttonText: 'Please try again'
} as const;

export { ERROR_BLOCK_DEFAULT_PROPS };
